<template>
  <el-main>
    <el-row class="unauthorized-error-page" type="flex" justify="center" align="middle">
      <el-col :xs="24" :sm="16" class="splash-holder">
        <!--<img src="@/assets/images/logo_scb.png" alt="SCB Payin Slip" class="logo">-->
        <h1>คุณไม่ได้รับอนุญาตให้เข้าถึงข้อมูลของระบบนี้</h1>
        <h3>กรุณาเข้าสู่เว็ปไซต์ที่ตรงกับบัญชีผู้ใช้ของคุณเพื่อใช้งานระบบ</h3>
      </el-col>
    </el-row>
  </el-main>
</template>

<script>
export default {
  name: 'UnauthorizedError',
};
</script>

<style lang="scss">
  .unauthorized-error-page {
    text-align: center;
    padding: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/error/unauthorized.vue